import Mutations from '../../odata/mutations';

export default { ...new Mutations('tipAlternative'), ...new Mutations('tipAlternatives') };
